export enum PasswordLength {
  PASSWORD_MIN = 8,
}
